import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=e0a72114&scoped=true&"
import script from "./AppBody.ts?vue&type=script&lang=ts&"
export * from "./AppBody.ts?vue&type=script&lang=ts&"
import style0 from "./AppBody.scss?vue&type=style&index=0&id=e0a72114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a72114",
  null
  
)

export default component.exports